import { useState, useEffect } from "react";
import "../../styles/HomeComponents/Advantages.css";
import advantageImage from "../../assets/Images/bg2_1 - Copy.webp";
import learnersImage from "../../assets/Images/Group222.webp";
import { Link } from "react-router-dom";

const steps = [
  {
    id: 1,
    title: "Discover Tailored Learning Experience",
    content: `Discover instructors who see the unique potential in every learner and know exactly how to nurture it into remarkable skills that last a lifetime—whether you're beginning your journey or supporting someone else's.`,
  },
  {
    id: 2,
    title: "Connect with a Vibrant Learning Community",
    content: `Step into a supportive network where growth happens naturally alongside peers who share your interests, guided by mentors who remember what it's like to discover something amazing for the first time.`,
  },
  {
    id: 3,
    title: "Find courses to unlock your true potential",
    content: `From robotics to piano, creative writing to chess—explore possibilities that conventional education simply can't provide. Find those special abilities that make you or your child uniquely brilliant in ways standardized testing never measures.`,
  },
];

function StrawketAdvantage() {
  const [activeStep, setActiveStep] = useState(1);

  useEffect(() => {
    if (window.innerWidth < 600) {
      const heading = document.querySelector(".emp-heading");
      if (heading) {
        heading.innerHTML =
          "Unlock your potential with personalized learning experiences tailored just for you";
      }
    }
  }, []);
  return (
    <>
      <div>
        <div className="advantage-head">
          <h2 className="title">The Strawket advantage</h2>
          <p className="subtitle">
            Transforming learning into a transformative experience
          </p>
        </div>
        <div className="strawket-advantage">
          <div className="advantage-left">
            <img src={advantageImage} alt="Learning Illustration" />
          </div>

          <div className="advantage-right">
            {steps.map((step) => (
              <div
                key={step.id}
                className={`advantage-box ${
                  activeStep === step.id ? "active" : ""
                }`}
                onClick={() => setActiveStep(step.id)}
              >
                <div
                  className={`circle ${activeStep === step.id ? "" : "gray"}`}
                >
                  {step.id.toString().padStart(2, "0")}
                </div>
                <div className="step-content">
                  <p className="mini-title">{step.title}</p>
                  <div
                    className={`step-description ${
                      activeStep === step.id ? "show" : "hide"
                    }`}
                  >
                    <p>{step.content}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="empowering-container">
        <div className="empowering-left">
          <h2 className="emp-heading">
            Empowering learners to <br />
            find their perfect match <br />
            with exceptional educators
          </h2>
          <p>
            At Strawket, we believe that every learner deserves access to the
            best teachers. Our mission is to bridge the gap between students and
            educators, creating a vibrant community of knowledge and growth.
          </p>
          <Link to="/academies">
            <button className="empower-button">Know More</button>
          </Link>
        </div>
        <div className="empowering-right">
          <img src={learnersImage} alt="Educator and student" />
        </div>
      </div>
    </>
  );
}

export default StrawketAdvantage;
